import Events from '_utils/events';
import { mapActions } from 'vuex';
import DistributorService from '_services/rest/modules/distributor';
import { _DELETE_DISTRIBUTOR_, _UPDATE_DISTRIBUTOR_STATUS_ } from './DistributorModel';

export default {
  name: 'distributor-actions',
  data() {
    return {
      selectDistributor: null,
    };
  },
  methods: {
    ...mapActions(['setToggle', 'activeAlert', 'deleteDistributor']),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    blockAccess(reseller) {
      this.setToggle({ type: 'progress', bool: true });
      const status = (reseller.status === 1) ? 0 : 1;
      DistributorService.toggleStatus(reseller.id, status)
        .then(() => {
          Events.$emit(_UPDATE_DISTRIBUTOR_STATUS_);
          this.activeAlert({
            message: 'Status do distribuidor atualizado com sucesso',
            theme: 'success',
          });
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        })
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    toggleDirectSales(reseller) {
      this.setToggle({ type: 'progress', bool: true });
      const status = (reseller.direct_sales === 1) ? 0 : 1;
      DistributorService.toggleDirectSales(reseller.id, status)
        .then(() => {
          this.activeAlert({
            message: 'Venda direta do distribuidor atualizado com sucesso',
            theme: 'success',
          });
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        })
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      this.deleteDistributor(this.selectDistributor)
        .then(() => {
          this.close();
          Events.$emit('update:pagination', false);
          this.$router.push('/admin/distribuidores/lista/1');
          this.activeAlert({
            message: 'Distribuidor deletado com sucesso',
            theme: 'success',
          });
        })
        .catch(error =>
          this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
  mounted() {
    Events.$on(_DELETE_DISTRIBUTOR_, distributor => {
      this.selectDistributor = distributor.id;
    });
  },
  destroyed() {
    Events.$off(_DELETE_DISTRIBUTOR_);
  }
};
